module.exports = __webpack_public_path__ + "static/media/icon-clock-white.8e210b40.svg";